import React, { useState, useEffect } from "react";
import ReactIdSwiper from "react-id-swiper";

export default (props) => {
  // //console.log(props);
  var data = props.data;
  // Swiper instance
  const [swiper, updateSwiper] = useState(null);
  // Slides current index
  const [currentIndex, updateCurrentIndex] = useState(0);
  var elePagi = ".swiper-pagination";
  if (props.page == "home-banners") {
    elePagi = ".swiper-pagination.swiper-pagination-white";
  }
  var params = {};
  // Params definition
 (props.page == "dr-carousel-unit")
    params = {
      loop: true,
      slidesPerView: 4.35,
      spaceBetween: 5,
      breakpoints: {
        767: {
          slidesPerView: 3.7,
          spaceBetween: 5
        }
      },
      getSwiper: updateSwiper // Get swiper instance callback
    }
  

  // Manipulate swiper from outside
  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  // Add eventlisteners for swiper after initializing
  useEffect(() => {
    if (swiper !== null) {
      swiper.on("slideChange", () => updateCurrentIndex(swiper.realIndex));
    }

    return () => {
      if (swiper !== null) {
        swiper.off("slideChange", () => updateCurrentIndex(swiper.realIndex));
      }
    };
  }, [swiper]);

  return (
    <div>
      <ReactIdSwiper {...params}>
        {data.map((item, idx) => (
          (props.page == "dr-carousel-unit" ?
            <div className="swiper-slide_feed_parenting_tool " key={idx}>
              <div className="all_tools_bar">
                  <div className="parenting_tools-icons"> 
                      <a href={item.desktopUrl} aria-hidden="true" tabIndex={-1}>
                       <img src={item.iconSvg} alt={`Parenting tool - ${item.eventName}`} title={item.eventName} className="gtm-tool" data-name={item.eventName} />
                      </a>
                  </div>
                <div className="nav-tools-heading R12_42"><a href={item.desktopUrl} className="gtm-tool" data-name={item.eventName} tabIndex={0} aria-label={`Go to parenting tool : ${item.eventName}`}> {item.eventName} </a></div> 
              </div>
            </div>
            :
            <div className="swiper-slide_feed" key={idx}>
              <img src="https://bbcdnlivemumbai.s3.ap-south-1.amazonaws.com/brainbees/community/memoryimages/1584339297p4706331.jpeg" alt="" />
            </div>
          )
        ))}
      </ReactIdSwiper>
      <div className="buttons buttons-list" style={{ display: "none" }}>
        <button id="prevSlide" className="button is-primary" onClick={goPrev} aria-label="Previous Slide">
          Prev
        </button>
        <button id="nextSlide" className="button is-primary" onClick={goNext} aria-label="Next Slide">
          Next
        </button>
      </div>
    </div>
  );
};
